import { render, staticRenderFns } from "./SetAutoRemoveDaysAdmin.vue?vue&type=template&id=66a1123f&"
import script from "./SetAutoRemoveDaysAdmin.vue?vue&type=script&lang=js&"
export * from "./SetAutoRemoveDaysAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports